import { useState } from 'react';

type ProfileAvatarProps = {
	src?: string;
	alt: string;
	size: number;
	emojiSize: number;
	className?: string;
};

const ProfileAvatar = ({
	src,
	alt,
	size,
	emojiSize,
	className = '',
}: ProfileAvatarProps) => {
	const [failedSrc, setFailedSrc] = useState<string | null>(null);

	if (!src || failedSrc === src) {
		return (
			<div
				className={`flex shrink-0 items-center justify-center rounded-full bg-mantang-gray-100 ${className}`.trim()}
				style={{ width: size, height: size }}
				aria-label={alt}
				role="img"
			>
				<span
					aria-hidden="true"
					style={{
						fontFamily: 'Tossface',
						fontSize: emojiSize,
						lineHeight: 1,
					}}
				>
					😊
				</span>
			</div>
		);
	}

	return (
		<img
			src={src}
			alt={alt}
			onError={() => setFailedSrc(src)}
			className={`shrink-0 rounded-full object-cover ${className}`.trim()}
			style={{ width: size, height: size }}
		/>
	);
};

export default ProfileAvatar;
